module.exports = __webpack_public_path__ + "img/website_bundle.ec68cf20.png";